<template>
  <div class="container">
    <!-- 左边img -->
    <div class="login-left"></div>
    <!-- 右边登录 -->
    <div class="login-right">
      <div class="login-form">
        <div class="login-item">
          <h3 class="title">{{register}}</h3>
          <div style="color:#ED6C00;cursor: pointer;" v-if="msg==true&&acc==true&&acces==false" @click="famsg">使用账号密码登录</div>
          <div v-if="toLogin&&msg==true&&msges==false && register == '登录'" style="color:#ED6C00;cursor: pointer;" @click="trmsg">使用验证码登录</div>
        </div>
        <!-- 这是验证码登录 -->
        <div v-if="toLogin&&msg==true&&msges==true&&acces==false && register == '登录'">
          <Input size="large" v-model="loginForm.usercode" placeholder="请输入手机号" class="login-input"></Input>
          <div class="login-code login-input">
            <Input size="large" v-model="loginForm.logincode" placeholder="请输入验证码"></Input>
            <Button v-if="isbutton==true" type="warning" @click="getCodes">获取验证码</Button>
            <Button v-if="isbutton==false" type="warning">{{countcode}}s后重新获取</Button>
          </div>
          <div class="loginBtn" style="margin-bottom:0px" @click="handLgetHomeAllcode" @keyup.enter="handLgetHomeAllcode">登录</div>
        </div>
        <!-- 这是账号密码登录 -->
        <div v-if="toLogin &&acc==true&&acces==true&&msges==false&& register == '登录'">
          <Input size="large" v-model="loginForm.username" placeholder="账号" class="login-input"></Input>
          <Input size="large" v-model="loginForm.password" placeholder="密码" class="login-input" :type="eyeshow==false?'password':'text'" :icon="eyeshow==false?'ios-eye-outline':'ios-eye'" @on-click="eyeOutline"></Input>
          <div class="login-code login-input">
            <Input size="large" v-model="loginForm.code" placeholder="验证码"></Input>
            <img :src="codeUrl" alt="" @click="getCode">
          </div>
          <div class="login-sign">
            <Checkbox v-model="loginForm.rememberMe" class="login-check"> 记住密码</Checkbox>
            <div @click="handlLogin">立即注册</div>
          </div>
          <div class="loginBtn" style="margin-bottom:0px" @click="handLgetHomeAll" @keyup.enter="handLgetHomeAll">登录</div>
          <div style="margin-bottom:135px;color: #BCBCBC;cursor: pointer;text-align: center;margin-top:10px" @click="forget">忘记密码</div>
        </div>

        <!-- 立即注册 -->
        <div v-if="toLogin && register == '注册'">
          <Select v-model="registerVal.merchantId" class="login-input">
            <Option v-for="(item,index) in options" :value="item.merchantId" :key="index" placeholder="账号" >{{ item.merchantName }}</Option>
          </Select>
          <Input size="large" v-model="registerVal.number" placeholder="手机号" class="login-input"></Input>
          <div class="login-code" style="position:relative">
            <Input size="large" v-model="registerVal.code" style="width:72%" placeholder="验证码"></Input>
            <span v-show="show==true" @click="sendcodeLogins" style="border: 1px solid #ED6C00;padding: 0 6px;border-radius: 10px;margin-right: 0;">发送验证码</span>
            <span v-show="show==false" style="border: 1px solid #ED6C00;padding: 0 6px;border-radius: 10px;margin-right: 0;">已发送({{countLogin}})</span>
          </div>
          <div v-show="showHk" style="margin-top:22px;margin-bottom:22px">
            <drag-verify
              style="margin: 0 auto"
              :width="350"
              ref="dragVerify"
              handlerBg="#f3aa6e"
              :isPassing.sync="isPassing"
              text="请按住滑块拖动以发送验证码"
              successText="已发送"
              handlerIcon="el-icon-d-arrow-right"
              successIcon="el-icon-circle-check"
              @passcallback="passcallback"
            >
              <i v-show="!isPassing" slot="textBefore" class="el-icon-lock"></i>
            </drag-verify>
          </div>
          <div class="regin-text">已有账号 <span @click="goLogin">去登录</span></div>
          <div class="loginBtn" @click="registerNext">下一步</div>
        </div>

        <!-- 立即注册 -下一步 -->
        <div v-if="toLogin2 && register == '注册' && !toLogin">
          <Input size="large" v-model="registerVal.name" placeholder="门店名称" class="login-input"></Input>
          <Input size="large" v-model="registerVal.passwordNew" placeholder="登录密码" class="login-input" type="password"></Input>
          <Input size="large" v-model="registerVal.passwordOld" placeholder="确认密码" class="login-input" type="password"></Input>
          <div class="regin-text">已有账号 <span @click="goLogin">去登录</span></div>
          <div class="loginBtn" @click="loginEnd">完成</div>
        </div>

        <!-- 忘记密码 -->
        <div v-if="toLogin && register == '忘记密码'">
          <Input size="large" v-model="phone" placeholder="手机号" class="login-input"></Input>
          <div class="login-code login-input" style="position:relative">
            <Input size="large" v-model="phcode" style="width:100%" placeholder="验证码" ></Input>
            <span v-show="show1==true" @click="sendcodes">发送验证码</span>
            <span v-show="show1==false">已发送({{count}})</span>
          </div>
          <div v-show="showHks" style="margin-bottom:22px">
            <drag-verify
              style="margin: 0 auto"
              :width="350"
              ref="dragVerify"
              handlerBg="#f3aa6e"
              :isPassing.sync="isPassings"
              text="请按住滑块拖动以发送验证码"
              successText="已发送"
              handlerIcon="el-icon-d-arrow-right"
              successIcon="el-icon-circle-check"
              @passcallback="passcallbacks"
            >
              <i v-show="!isPassings" slot="textBefore" class="el-icon-lock"></i>
            </drag-verify>
          </div>
          <Input size="large" v-model="pgpaword" placeholder="密码为6-18位字母、数字组合" class="login-input"></Input>
          <Input size="large" v-model="againpaword" placeholder="再次输入密码" class="login-input"></Input>
          <div class="regin-text">已有账号 <span @click="goLogin">去登录</span></div>
          <div class="loginBtn" @click="forgetpaw" style="cursor: pointer;">完成</div>
        </div>

        <!-- 扫码登录 -->
        <div v-if="!toLogin && register == '登录'">
          <img src="../assets/image/logo.png" alt="" class="login-scan">
        </div>
        <!--  底部  -->
      </div>
      <!-- 成都 -->
      <div class="el-login-footer" @click="gxb">Copyright © 2024 蜀ICP备2021030101号-4</div>
      <div class="login-mobile">
        <div class="login-hover">
          <div>
            <img :src="isCd" style="width: 70px;height: 70px;" alt="">
            <!-- <img src="../assets/image/logo.png" > -->
            <span>微信订货</span>
          </div>
          <div>
            <qrcode id="qrCode1" :url="appSrc" :iconurl="logoSrc" :wid="70" :hei="70" :imgwid="15" :imghei="15"></qrcode>
            <span>APP订货</span>
          </div>
        </div>
        <div class="login-order">微信订货</div>
      </div>
      <!-- <div class="mask" v-show="modal"></div>
      <div class="modal-conpon" v-show="modal">
      <div class="title">
        <div class="tit">
          请选择您要登录的商户
        </div>
        <div class="merchant-content">
          <div class="item" v-for="(item,index) in merchantList" @click="handleItem(item,index)" :key="index">
            <img class="img" :src="item.logo" alt="">
            <div class="item-side">
              <div class="ts">{{item.merchantName}} <span v-if="item.state=='4'" style="font-size: 14px;color:#ED6C00">已停用</span></div>
              <div class="tb">{{item.address}}</div>
            </div>
            <img src="../assets/icon/login-err.png" alt="" class="arrow">
          </div>
        </div>
      </div>
    </div> -->
    </div>
  </div>
</template>


<script>
  import { login,getCodeImg,sendYzmCode,forgetpassword,registerVerify,getAllMerchant,sendRegisterCode,loginConfig,sendCode,loginSms,chooseCusetomerLogin } from "@/api/login";
  import { Button,Input,Checkbox } from "iview"
  import Cookies from "js-cookie";
  import { getToken, setToken, removeToken } from '@/utils/auth'
  import { eacaprHtmlGoods,eacaprHtml } from '@/utils/eacapr'
  import { getCustomerMerchantType} from "@/api/index";
  import { saveCustomerMerchant, setMerchantInfo } from "@/utils/merchant";
  import FingerprintJS from '@fingerprintjs/fingerprintjs'
  import { Plugins } from '@capacitor/core';
  import qrcode from 'vue_qrcodes';
  import unitfun from '@/utils/utilsFun.js';
import { error } from "shelljs";
  const { Device } = Plugins;

export default {
  name: 'Login',
  components:{
    Button,Input,Checkbox,qrcode
  },
  data () {
    return {
      merchantList:[],//商户列表
      modal:false,
      isbutton:true,
      isCd: require('../assets/image/wx-cd.png'),
      appSrc:'https://download.51rcyg.com/uni-salesman-download/pages/index/index?merchantName=蓉城易购&merchantId=1',
      register:'登录',
      logoSrc:require('../../static/favicon1.png'),// 二维码中间logo图片（选填）
      registerVal:{
        number:null,
        merchantId:null,
        code:null,
        name:null,
        passwordNew:null,
        passwordOld:null
      },
      showHk: false, // 是否展示滑块  点击登录按钮是 设置为true 同时隐藏登录按钮
      isPassing: false,
      showHks: false, // 是否展示滑块  点击登录按钮是 设置为true 同时隐藏登录按钮
      isPassings: false,
      tableData:{},
      codeUrl:null,
      index:123,
      value:null,
      single: false,
      toLogin:true, // 账号密码登录
      toLogin2:false,
      redirect:null,
      show:true,
      show1:true,
      countLogin:'',
      count:'',
      phone:'',
      phcode:'',
      pgpaword:'',
      againpaword:'',
      loginForm: {
        username: "",//admin
        password: "",//admin123
        rememberMe: false,
        code: "",
        uuid: "",
        usercode:"",
        logincode:""
      },
      options:[],
      accsse:true,
			acc:false,
			msg:false,
			acces:false,
			msges:false,
      countcode: '',
		  timer: null,
      eyeshow:false,
      deviceId: ''
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  created() {
    let params={
        way:'pc'
      }
    loginConfig(params).then(res => {
      if(res.code==200){
        for(let k=0;k<res.data.supports.length;k++){
          if(res.data.supports[k]=='acc'){
            this.acc=true
            this.acces=true
          }
          if(res.data.supports[k]=='msg'){
            this.msg=true
            this.msges=true
          }
        }
        if(this.acc==true){
          this.msges=false
        }else{
          this.accsse=false
        }
      }
    });
    let that=this
    document.onkeydown=function(e){
      let key=window.event.keyCode;
      if(key==13){
        if(that.acc==true&&that.acces==true&&that.msges==false){
          that.handLgetHomeAll()
        }
        if(that.msg==true&&that.msges==true&&that.acces==false){
          that.handLgetHomeAllcode()
        }
      }
    }
    this.getCode(); // 获取验证码
    this.getCookie();
    if(localStorage.getItem("clientToken")){
      setToken(localStorage.getItem("clientToken"))
      this.$router.beforeEach((to, from, next) => {
        localStorage.setItem('previousPath', from.path);
        next();
      });
      this.$router.push({ path: '/index' }).catch(()=>{});
      // this.$router.push("/index")
    }else{
      removeToken()
    }
    // if (this.isTablet()) {
    //   console.log('用户通过平板登录');
    //   this.getBoedId()
    // } else {
    //   console.log('用户通过电脑登录');
    //   this.getDeviceId()
    // }
  },
  destroyed(){ document.onkeydown = null },
  methods:{
    async getDeviceId() {
      try {
        const fp = await FingerprintJS.load();
        let id = await fp.get();
        this.deviceId = id.visitorId
        console.log('Device ID:', this.deviceId);
      } catch (error) {
        console.error('Error getting device ID:', error);
      }
    },
    async getBoedId() {
      const info = await Device.getInfo();
      this.deviceId = info.uuid; // 这是设备的唯一标识符
    },
    isTablet() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    },
    eyeOutline(){
      this.eyeshow=!this.eyeshow
    },
    gxb(){
        window.location.href = 'https://beian.miit.gov.cn/#/Integrated/index';
      },
    getCodes() {
      if(!this.loginForm.usercode){
        return this.$Message.info('请输入手机号!');
      }else if(!(/^1[3456789]\d{9}$/.test(this.loginForm.usercode))){
        this.$Message.error('手机格式不正确');
        return false;
      }
      let times=new Date().getTime();
		  let genKey = unitfun.aesUtil.duanxinKey();
		  let codes = unitfun.aesUtil.encrypt(times,genKey);
      let params={
          phoneNumber:this.loginForm.usercode,
          code:codes
        }
        sendCode(params).then(res=>{
        if(res.code==200) {
          this.isbutton=false
          this.$Message.success('验证码已发送');
          const TIME_COUNT = 60;
          if (!this.timer) {
              this.countcode = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                  if (this.countcode > 0 && this.countcode <= TIME_COUNT) {
                      this.countcode--;
                  } else {
                      this.isbutton = true;
                      clearInterval(this.timer);
                      this.timer = null;
                  }
              }, 1000)
          }
        }
      })
	  },
    famsg(){
			this.acces=true
			this.msges=false
		},
		trmsg(){
			this.acces=false
			this.msges=true
		},
    passcallback() {
      this.sendcodeLogin()
    },
    passcallbacks() {
     this.sendcode()
    },
    // 获取验证码
    getCode() {
      getCodeImg().then(res => {
        this.codeUrl = "data:image/gif;base64," + res.img;
        this.loginForm.uuid = res.uuid;
      });
    },
    // 获取cookie
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get('rememberMe')
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password === undefined ? this.loginForm.password : password,
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      };
    },
    // 清空注册
    reset(){
      this.$nextTick(function(){
        this.registerVal.number = null
        this.registerVal.merchantId = null
        this.registerVal.code = null
        }
      )
    },
    handLgetHomeAll(){
      if(!this.loginForm.username){
        return this.$Message.info('请填写账号!');
      }else if(!(/^1[3456789]\d{9}$/.test(this.loginForm.username))){
        this.$Message.error('手机格式不正确');
        return false;
      }
      if(!this.loginForm.password){
        return this.$Message.info('请填写密码!');
      }else{
        this.loginForm.password=eacaprHtml(this.loginForm.password);
      }
      if(!this.loginForm.code){
        return this.$Message.info('请输入验证码!');
      }else{
        this.loginForm.code=eacaprHtml(this.loginForm.code);
      }
      if (this.loginForm.rememberMe) {
        Cookies.set("username", this.loginForm.username, { expires: 30 });
        Cookies.set("password", this.loginForm.password, { expires: 30 });
        Cookies.set('rememberMe', this.loginForm.rememberMe, { expires: 30 });
      } else {
        Cookies.remove("username");
        Cookies.remove("password");
        Cookies.remove('rememberMe');
      }
      let pData = this.loginForm;
      pData.loginTerminal = '4'
      pData.platformId = 1
      login(pData).then((res) => {
        if(res.code == 200){
          setToken(res.token)
          localStorage.setItem("clientToken", res.token);
          localStorage.setItem("pageVisibleType", 'N');
          // 必须等商户信息落库后再跳转首页，
          // 否则首页 created() 读到的 merchantId 为空，appIndexV2 请求会丢商户参数
          this.getCustomerMerchant().then(()=>{
            this.$router.beforeEach((to, from, next) => {
            localStorage.setItem('previousPath', from.path);
              next();
            });
            this.$router.push({ path: '/index' }).catch(()=>{});
          }).catch(()=>{
            this.$router.push({ path: '/index' }).catch(()=>{});
          })
        }
      },error=>{
        this.getCode()
      })
    },
    // 获取聚合或者单店模式
    getCustomerMerchant(){
      return getCustomerMerchantType().then(res=>{
        if(res.code == 200){
          if(res.data.type != 'agg'){
            console.log('single',res.data.merchantName)
          }else{
            console.log('agg',res.data.groupName)
          }
          // 一次性落库 merchantId / merchantType / merchantGroupName
          const info = saveCustomerMerchant(res.data)
          setMerchantInfo({ oldMerchantId: res.data.defMerId })
          this.merchantType = info.merchantType
        }
        return res
      })
    },
    // handleItem(item,index){
    //   //状态  1待审核，2待激活，3已启用，4已停用，5审核不过
    //   if(item.state == 4){
    //     this.$Message.error('该商户已停用');
    //   }else if(item.state == 5){
    //     this.$Message.error('该商户审核未通过');
    //   }else if(item.state == 1){
    //     this.$Message.error('该商户待审核');
    //   }else{
    //     let array =  {}
    //     array.password = this.loginForm.password
    //     array.username = this.loginForm.username
    //     array.merchantId = item.merchantId
    //     chooseCusetomerLogin(array).then(res=>{
    //       setToken(res.token)
    //       if(res.loginType == 'client' && res.token){
    //         this.$router.beforeEach((to, from, next) => {
    //           localStorage.setItem('previousPath', from.path);
    //           next();
    //         });
    //          this.$router.push({ path: '/index' }).catch(()=>{});
    //          window.localStorage.setItem('clientToken',res.token)
    //       }

    //     })
    //   }
    // },
    handLgetHomeAllcode(){
      if(!this.loginForm.usercode){
        return this.$Message.info('请输入手机号!');
      }else if(!(/^1[3456789]\d{9}$/.test(this.loginForm.usercode))){
        this.$Message.error('手机格式不正确');
        return false;
      }
      if(!this.loginForm.logincode){
        return this.$Message.info('请输入验证码!');
      }
      let a=eacaprHtml(this.loginForm.usercode);
			let b=eacaprHtml(this.loginForm.logincode);
      let params={
				username:a,
				code:b,
        loginTerminal:'4',
        platformId:1
			}
      loginSms(params).then((res) => {
        if(res.code == 200){
          setToken(res.data.token)
          localStorage.setItem("clientToken", res.data.token);
          localStorage.setItem("pageVisibleType", 'N');
          this.$router.beforeEach((to, from, next) => {
              localStorage.setItem('previousPath', from.path);
              next();
            });
          this.$router.push({ path: '/index' }).catch(()=>{});
        }
      })
    },
    sendcodeLogins(){
      this.showHk=true
    },
    sendcodeLogin(){
      if(!this.registerVal.number){
        this.$refs.dragVerify.reset();
        // 把滑块隐藏  登录按钮显示
        this.showHk = false;
        // 把滑块完成状态修改为未完成
        this.isPassing = false;
        return this.$Message.info('请输入手机号!');
      }else if(!(/^1[3456789]\d{9}$/.test(this.registerVal.number))){
        this.$refs.dragVerify.reset();
        // 把滑块隐藏  登录按钮显示
        this.showHk = false;
        // 把滑块完成状态修改为未完成
        this.isPassing = false;
        this.$Message.error('手机格式不正确');
        return false;
      }
      if(!this.registerVal.merchantId){
        this.$refs.dragVerify.reset();
        // 把滑块隐藏  登录按钮显示
        this.showHk = false;
        // 把滑块完成状态修改为未完成
        this.isPassing = false;
        return this.$Message.info('请先选择商户!');
      }
      let times=new Date().getTime();
      let genKey = unitfun.aesUtil.duanxinKey();
      let codes = unitfun.aesUtil.encrypt(times,genKey);
      let params={}
      params.code=codes
      params.merchantId = this.registerVal.merchantId,
      params.phoneNumber = this.registerVal.number
      sendRegisterCode(params).then(res => {
        if(res.code==200){
          this.$Message.success('发送成功!');
          const TIME_COUNT = 60;
          this.countLogin = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            this.$refs.dragVerify.reset();
            // 把滑块隐藏  登录按钮显示
            this.showHk = false;
            // 把滑块完成状态修改为未完成
            this.isPassing = false;
             if (this.countLogin > 0 && this.countLogin <= TIME_COUNT) {
                  this.countLogin--;
              } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
              }
          }, 1000)
        }
      },error=>{
        this.showHk = false
        this.isPassing = false;
        this.$refs.dragVerify.reset();
      }
      );
    },
    sendcodes(){
      this.showHks=true
    },
    sendcode(){
      if(this.phone==''){
        this.$refs.dragVerify.reset();
        // 把滑块隐藏  登录按钮显示
        this.showHks = false;
        // 把滑块完成状态修改为未完成
        this.isPassings = false;
        return this.$Message.info('请输入手机号!');
      }else if(!(/^1[3456789]\d{9}$/.test(this.phone))){
        this.$refs.dragVerify.reset();
        // 把滑块隐藏  登录按钮显示
        this.showHks = false;
        // 把滑块完成状态修改为未完成
        this.isPassings = false;
        this.$Message.error('手机格式不正确');
        return false;
      }
      let times=new Date().getTime();
      let genKey = unitfun.aesUtil.duanxinKey();
      let codes = unitfun.aesUtil.encrypt(times,genKey);
      let params={
        phoneNumber:this.phone,
        code:codes
      }
      sendYzmCode(params).then(res => {
        if(res.code==200){
          const TIME_COUNT = 60;
          this.count = TIME_COUNT;
          this.show1 = false;
          this.timer = setInterval(() => {
            this.$refs.dragVerify.reset();
            // 把滑块隐藏  登录按钮显示
            this.showHks = false;
            // 把滑块完成状态修改为未完成
            this.isPassings = false;
             if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
              } else {
                  this.show1 = true;
                  clearInterval(this.timer);
                  this.timer = null;
              }
          }, 1000)
        }
      });
    },
    forgetpaw(){
      if(this.phone==''){
        return this.$Message.info('请输入手机号!');
      }else if(!(/^1[3456789]\d{9}$/.test(this.phone))){
        this.$Message.error('手机格式不正确');
        return false;
      }
      if(this.phcode==''){
        return this.$Message.info('请输入验证码');
      }
      if(this.pgpaword==''){
        return this.$Message.info('请输入密码!');
      }
      if(this.againpaword!=this.pgpaword){
        return this.$Message.info('两次输入密码不一致!');
      }
      let a=eacaprHtml(this.phcode);
			let b=eacaprHtml(this.pgpaword);
      let c=eacaprHtml(this.phone);
      let params={
        code:a,
        newPassword:b,
        username:c
      }
       forgetpassword(params).then(res => {
        console.log(res)
        if(res.code==200){
          this.$Message.success('修改成功');
          this.register = '登录'
          this.toLogin = true
          this.phcode=''
          this.phone=''
          this.pgpaword=''
          this.againpaword=''
        }
      });
    },
    //忘记密码
    forget(){
      this.register = '忘记密码'
    },
    // 立即注册
    handlLogin(){
      this.register = '注册'
      getAllMerchant().then(res=>{
        this.options = res.data;
      })
    },
    goLogin(){
      this.register = '登录'
      this.toLogin = true
      this.phcode=''
      this.phone=''
      this.pgpaword=''
      this.againpaword=''
      this.registerVal.number=''
      this.registerVal.code=''
      this.registerVal.name=''
      this.registerVal.passwordNew=''
      this.registerVal.passwordOld=''
      this.registerVal.merchantId=''
      this.reset()
    },
    handlImg(){
      // this.toLogin = !this.toLogin
    },
    registerNext(){
      if(!this.registerVal.merchantId){
        this.$Message.error('请选择商户！')
        return false
      }else if(!this.registerVal.number){
        this.$Message.error('请输入手机号！')
        return false
      }else if(!(/^1[3456789]\d{9}$/.test(this.registerVal.number))){
        this.$Message.error('手机格式不正确');
        return false;
      }else if(!this.registerVal.code){
        this.$Message.error('请输入验证码！')
        return false
      }
      this.toLogin = false;
      this.toLogin2 = true;
    },
    loginEnd(){
      if(!this.registerVal.name){
        this.$Message.error('请输入门店名称！');
        return false;
      }else{
        this.registerVal.name=eacaprHtml(this.registerVal.name);
      }
      if(!this.registerVal.passwordNew){
        this.$Message.error('请输入登录密码！');
        return false;
      }else{
        this.registerVal.passwordNew=eacaprHtml(this.registerVal.passwordNew);
      }
      if(!this.registerVal.passwordOld){
        this.$Message.error('请输入确认密码！');
        return false;
      }else{
        this.registerVal.passwordOld=eacaprHtml(this.registerVal.passwordOld);
      }
      if(this.registerVal.passwordNew != this.registerVal.passwordOld){
        this.$Message.error('两次密码输入不一致！');
        return false;
      }
      let postData = {},array = Object.assign({},this.registerVal)
      postData.merchantId = array.merchantId
      postData.username = array.number
      postData.code = array.code
      postData.name = array.name
      postData.password = array.passwordOld
      registerVerify(postData).then(res => {
        if(res.code == 200){
          this.register = '登录'
          this.toLogin = true
          this.$Message.success(res.msg)
          this.reset()
        }
      });
    },
  }
}
</script>


<style scoped lang="scss">
::v-deep .ivu-btn-warning{
  background-color: #fff;
  color:#f90
}
.container{
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-sizing: border-box;
    width: 1140px;
    height: 640px;
    background: #FFFFFF;
    box-shadow: 0 10px 15px 0 #ccc;
    border-radius: 30px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -570px;
    margin-top: -320px;
    .login-left{
      width: 50%;
      height: 100%;
      background-image: url("../assets/image/loginmap2.png");//成都
      background-size: 100% 100%;
    }
    .login-right{
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .login-form {
        height: 600px;
        border-radius: 6px;
        background: #ffffff;
        width: 400px;
        padding: 25px 25px 5px 25px;
        .login-item{
          display: flex;
          justify-content: space-between;
          img{
            width: 52px;
            height: 52px;
          }
        }
        .login-input{
          margin-bottom: 22px;
        }
        .login-sign{
          display: flex;
          justify-content: space-between;
          color: #BCBCBC;
          cursor: pointer;
          .login-check{
            border-radius: 50%;
          }
        }
        .login-scan{
          width: 100%;
          height: 340px;
          padding:20px;
          background: #FFFDF8;
          border: 1px solid #CDCDCD;
          border-radius: 10px;
          margin-bottom: 113px;
        }
        .loginBtn{
         width: 100%;
         background: #ED6C00;
         border-radius: 4px;
         font-size: 14px;
         color: #FFF;
         margin-top: 25px;
         text-align: center;
         padding:6px 0;
         margin-bottom: 210px;
       }

        .title {
          margin: 0 0 20px;
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #ED6C00;
        }
        .input-icon {
          height: 39px;
          width: 14px;
          margin-left: 2px;
        }

      }
      .login-mobile{
        cursor: default;
         border: 1px solid #AAAAAA;
         border-radius: 16px;
         text-align: center;
         position: absolute;
         bottom: 92px;
         right: 10px;
         width: 76px;
         .login-hover{
           display: none;
         }
         .login-hover div img{
           width: 46px;
           height: 44px;
         }
        .login-hover div span{
          display: block;
          color: #606060;
        }
        .login-order{
          padding: 3px 8px;
          color: #424242;
        }
      }
    }
  }
  .el-login-footer {
    height: 40px;
    line-height: 40px;
    width: 100%;
    color: #606060;
    position: absolute;
    bottom: 85px;
    text-align: center;
    font-family: Source Han Sans CN;
    font-size: 14px;
    letter-spacing: 1px;
    // margin-top: 10px;
  }
  .login-code{
    display: flex;
    justify-content: space-between;
    input{
      width: 63%;
    }
    img{
      width: 40%;
      height: 34px;
      margin-left: 10px;
    }
    span{
      // width: 40%;
      position: absolute;
      right: 0;
      height: 34px;
      line-height: 34px;
      margin-right: 10px;
      text-align: right;
      color:#ED6C00;
      cursor: pointer;
    }
  }
  .container .login-right .login-mobile:hover .login-hover{
    display: block;
    margin:7px 0;
  }
  .regin-text{
    color: #BCBCBC;
    cursor: pointer;
    span{
      color: #ED6C00;
    }
  }
  .mask{
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 10000;
  }
  .modal-conpon{
    width: 580px;
    height: 520px;
    background-color: #FFFFFF;
    border-radius: 30px;
    position: fixed;
    top:50%;
    left: 50%;
    margin-left: -290px;
    margin-top: -283px;
    z-index: 10001;
    padding: 20px;
    .title{
      // display: flex;
      // justify-content:center;
      // align-items: center;
      padding: 0 10px;
    }
    .tit{
      font-size: 26px;
      margin-bottom: 20px;
    }
    .merchant-content{
      height: 420px;
      overflow-y: auto;
      // width: 600px;
      // margin-left: auto;
      // margin-right: auto;
      .item{
        border: 1px solid #d7d7d7;
        background-color: #fff;
        border-radius: 20px;
        padding: 10px 20px;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .img{
          height: 80px;
          // width: 88px;
          margin-right: 10px;
        }
        .item-side{
          flex: 1;
          .ts{
            font-size: 22px;
            margin-bottom: 10px;
            font-size: #606060;
          }
          .tb{
            font-size: 6px;
            font-size: #606060;
          }
        }
        .arrow{
          height: 24px;
          width: 24px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue